export default "__VITE_ASSET__2FnMQbCS__"